module.exports = __webpack_public_path__ + "assets/img/noNotice.fae6ede0.png";